import isEmpty from "lodash/isEmpty";
import { arrowBackOutline, close } from "ionicons/icons";
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonLabel,
  IonBackButton,
  IonTitle,
} from "@ionic/react";
import ShareIcon from "../../assets/logo/share-08.svg";

import cx from "classnames";
import s from "./WLCommonBasicHeader.module.scss";

import { WLCOLORS, WLCOLORSTYPES } from "../../config/global";
import { useUserStore as AdminUserStore } from "../../../Admin/stores";
import { useUserStore as AppUserUserStore } from "../../../AppUser/CommonStores";
import { shallow } from "zustand/shallow";
import { DASHBOARD } from "../../../AppUser/constants/routes";

export interface WLCommonBasicHeaderProps {
  className?: string;
  title?: string;
  overrideBackRoute?: string;
  overrideBackFunction?: () => void;
  onClickClose?: () => void;
  onClickSkip?: () => void;
  noBackButton?: boolean;
  headerClassName?: string;
  darkMode?: boolean;
  background?: string;
  customTitleClassName?: string;
  customTitleColor?: WLCOLORSTYPES;
  disableNativePaddingTop?: boolean;
}

export const WLCommonBasicHeader = (props: WLCommonBasicHeaderProps) => {
  const {
    className,
    title,
    overrideBackRoute,
    overrideBackFunction,
    onClickClose,
    onClickSkip,
    noBackButton,
    headerClassName,
    darkMode,
    background,
    customTitleClassName,
    customTitleColor,
    disableNativePaddingTop,
  } = props;

  const textColor = darkMode ? WLCOLORS.light : WLCOLORS.dark;

  // const user = useUserStore((state) => state.user, shallow);
  const appUser = AppUserUserStore((state) => state.user, shallow);
  const adminUser = AdminUserStore((state) => state.user, shallow);
  return (
    <IonHeader
      className={cx(s.wlV2Header, headerClassName, darkMode ? s.darkMode : "", {
        [s.disableNativePaddingTop]: !!disableNativePaddingTop,
      })}
      style={{ background: background, "--background": background }}
    >
      <IonToolbar
        className={cx(
          s.wlHeaderToolbar,
          "win-body medium gilroy dark",
          className
        )}
        style={{ background: background, "--background": background }}
      >
        <IonButtons className={s.wlHeaderStartSlotButtons} slot="start">
          {overrideBackRoute !== undefined &&
          !isEmpty(overrideBackRoute) &&
          !noBackButton ? (
            <IonButton
              className={s.headerButton}
              color={textColor}
              routerLink={overrideBackRoute}
              routerDirection="back"
            >
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          ) : overrideBackFunction !== undefined && !noBackButton ? (
            <IonButton
              className={s.headerButton}
              color={textColor}
              onClick={overrideBackFunction}
            >
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          ) : !noBackButton ? (
            <IonBackButton
              color={textColor}
              text=""
              icon={arrowBackOutline}
              defaultHref={!appUser && !adminUser ? "/" : DASHBOARD}
            />
          ) : (
            <></>
          )}
        </IonButtons>
        {title && (
          // <div
          //   style={{
          //     width: onClickClose ? "110%" : "100%",
          //     textAlign: "center",
          //   }}
          // >
          //   <IonLabel
          //     className={customTitleClassName}
          //     color={customTitleColor ? WLCOLORS[customTitleColor] : textColor}
          //   >
          //     {title}
          //   </IonLabel>
          // </div>
          <IonTitle
            className={cx(s.headerTitle, customTitleClassName)}
            color={customTitleColor ? WLCOLORS[customTitleColor] : textColor}
          >
            {title}
          </IonTitle>
        )}
        {onClickClose && (
          <IonButtons slot="end">
            <IonButton
              className={s.headerButton}
              onClick={onClickClose}
              fill="clear"
              color={textColor}
            >
              <IonIcon icon={close} />
            </IonButton>
          </IonButtons>
        )}
        {onClickSkip && (
          <IonButtons slot="end">
            <IonButton
              className={cx(s.headerButton, "win-body medium winnersans dark")}
              onClick={onClickSkip}
              fill="clear"
              color={textColor}
            >
              SKIP
            </IonButton>
          </IonButtons>
        )}
      </IonToolbar>
    </IonHeader>
  );
};
